import React from 'react';

const EnvelopIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19.109" viewBox="0 0 24 19.109"><g transform="translate(-0.836 -0.703)"><path d="M6.508.971a71.227,71.227,0,0,1,12.337,0l1.978.172a3.783,3.783,0,0,1,3.028,2.023.309.309,0,0,1-.119.4l-8.2,5.079a5.565,5.565,0,0,1-5.76.059L1.507,3.826a.309.309,0,0,1-.135-.384,3.783,3.783,0,0,1,3.158-2.3Z" transform="translate(0.159)" fill="#0f4975"/><path d="M1.525,4.845a.324.324,0,0,0-.489.245,39.742,39.742,0,0,0,.241,9.9A3.782,3.782,0,0,0,4.69,18.194l1.978.172a71.224,71.224,0,0,0,12.337,0l1.978-.172a3.782,3.782,0,0,0,3.412-3.205A39.74,39.74,0,0,0,24.6,4.8a.324.324,0,0,0-.494-.239L16.72,9.139a7.529,7.529,0,0,1-7.793.08Z" transform="translate(0 1.179)" fill="#0f4975"/></g></svg>
  );
};

export default EnvelopIcon;
